Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    selectIosToolbarHeight: 44,
    selectIosToolbarBackgroundColor: tokens.themePageHighlight,
    selectIosToolbarForegroundColor: tokens.themeActionPrimaryDefault,
    selectIosToolbarBorderWidth: 1,
    selectIosToolbarBorderRadius: 0,
    selectIosToolbarBorderColor: tokens.themeBorderDefault,
    selectIosToolbarSpacingHorizontal: 16,
    selectIosPickerMotionDuration: "200ms",
    selectIosPickerMotionFunction: "ease",
    selectOptionListElevation: 70,
    selectOptionListBorderWidth: 1,
    selectOptionListBorderRadius: 4,
    selectOptionListBorderColor: tokens.themeBorderFormfield,
    selectOptionListShadowOffsetX: 0,
    selectOptionListShadowOffsetY: 2,
    selectOptionListShadowBlur: 4,
    selectOptionListShadowSpread: 0,
    selectOptionListShadowColor: "#02080E",
    selectOptionListShadowOpacity: 16,
    selectOptionListPopoverOffsetVertical: 4,
    selectOptionListPopoverBreakpoint: 721,
    selectOptionListBackgroundColor: tokens.themePageDefault,
    selectOptionListForegroundColor: tokens.themeInkDefault,
    selectSearchInputForegroundColorDefault: tokens.themeInkDefault,
    selectSearchInputPlaceholderColorDefault: tokens.themeInkSubdued,
    selectSearchInputPlaceholderColorDisabled: tokens.themeInkDisabled
  }
};